module.exports = __webpack_public_path__ + "img/Allen Farley.babfc817.jpg";